import { Box, OverflowMenu, MenuItem, MenuItemLink } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import config from '@/config'
import { Modals } from '../types'

type OptionsMenuProps = {
  trustScoreInfo: any
  showModal: (modal: keyof Modals) => () => void
  setDeleteId: (deleteId: string) => void
}

export const OptionsMenu = ({ trustScoreInfo, showModal, setDeleteId }: OptionsMenuProps) => {
  const { t } = useTranslation()

  return (
    <Box justifyContent="center">
      <OverflowMenu
        label="Options"
        id="options"
        data={{ testId: `options-menu-${trustScoreInfo.id}` }}
      >
        {trustScoreInfo.status === 'expired' || trustScoreInfo.status === 'draft' ? (
          <MenuItem disabled>
            {t('l.standalone-trustscore.list.table.overflow_menu.export_to_pdf', 'Export to PDF')}
          </MenuItem>
        ) : (
          <MenuItemLink
            href={`${config.BACKEND_SERVER}/trust_score/standalone/${trustScoreInfo.id}/application.pdf`}
            target="_blank"
          >
            {t('l.standalone-trustscore.list.table.overflow_menu.export_to_pdf', 'Export to PDF')}
          </MenuItemLink>
        )}

        <MenuItem
          onClick={() => {
            setDeleteId(trustScoreInfo.id)
            showModal('deleteTrustScoreDialog')()
          }}
          tone="critical"
        >
          {t('l.standalone-trustscore.list.table.overflow_menu.delete', 'Delete')}
        </MenuItem>
      </OverflowMenu>
    </Box>
  )
}
